"use client";

import { c as _c } from "react/compiler-runtime";
import { Countdown, Flex, TextBody } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { useDropStore } from "@/components/collection/drops/components/CollectionDropContext";
import { HeroHeaderViewToggle } from "@/components/hero-header/HeroHeaderViewToggle";
export function CollectionHeaderDropCountdown(t0) {
  const $ = _c(11);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "full" : t1;
  const dropStart = useDropStore(_temp);
  const t = useTranslations("CollectionHeaderDropCountdown");
  if (!dropStart) {
    return null;
  }
  let t2;
  if ($[0] !== t) {
    t2 = t("mintingIn");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <TextBody className="font-mono text-text-secondary uppercase" size="sm">{t2}</TextBody>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = variant === "compact" ? "sm" : "lg";
  let t5;
  if ($[4] !== dropStart || $[5] !== t4) {
    t5 = <Countdown end={dropStart} showDaysOnly={true} size={t4} />;
    $[4] = dropStart;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <HeroHeaderViewToggle />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t5) {
    t7 = <Flex className="items-center gap-4">{t3}{t5}{t6}</Flex>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}
function _temp(state) {
  return state.dropStart;
}